import { render } from "./MagicItems.vue?vue&type=template&id=5784eedc&scoped=true"
import script from "./MagicItems.vue?vue&type=script&lang=js"
export * from "./MagicItems.vue?vue&type=script&lang=js"

import "./MagicItems.vue?vue&type=style&index=0&id=5784eedc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5784eedc"]])

export default __exports__